// extracted by mini-css-extract-plugin
export default {"appshell":"igsosaApp_appshell__U-2-z"};